import React, { useState, useEffect } from 'react';
import { FiUser, FiCheckCircle, FiAlertCircle, FiClock, FiAward } from 'react-icons/fi';
import { adminAPI } from '../../../services/api';

const TestResultsPage = () => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState({ studentId: '', testId: '' });
    const [students, setStudents] = useState([]);
    const [tests, setTests] = useState([]);

    useEffect(() => {
        loadData();
    }, [filter]);

    const loadData = async () => {
        try {
            setLoading(true);
            const [resultsRes, studentsRes, testsRes] = await Promise.all([
                adminAPI.getStandaloneTestResults(filter),
                adminAPI.getStudents(),
                adminAPI.getStandaloneTests()
            ]);
            setResults(resultsRes.data.results || []);
            setStudents(studentsRes.data.students || []);
            setTests(testsRes.data.tests || []);
        } catch (error) {
            console.error('Ошибка загрузки данных:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div style={{ padding: '20px', textAlign: 'center' }}>Загрузка...</div>;
    }

    return (
        <div style={{ maxWidth: 1200, margin: '-20px auto 0', padding: '0 20px 20px' }}>
            <h1 style={{ margin: '0 0 18px 0' }}>Результаты тестирования</h1>

            {/* Фильтры */}
            <div className="card" style={{ marginBottom: '20px', padding: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
                    <div className="form-group" style={{ marginBottom: 0 }}>
                        <label>Студент</label>
                        <select
                            value={filter.studentId}
                            onChange={(e) => setFilter({ ...filter, studentId: e.target.value })}
                        >
                            <option value="">Все студенты</option>
                            {students.map(student => (
                                <option key={student.id} value={student.id}>
                                    {student.first_name} {student.last_name} ({student.username})
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group" style={{ marginBottom: 0 }}>
                        <label>Тест</label>
                        <select
                            value={filter.testId}
                            onChange={(e) => setFilter({ ...filter, testId: e.target.value })}
                        >
                            <option value="">Все тесты</option>
                            {tests.map(test => (
                                <option key={test.id} value={test.id}>
                                    {test.title}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>

            {/* Результаты */}
            {results.length === 0 ? (
                <div className="card" style={{ padding: '60px', textAlign: 'center' }}>
                    <p style={{ fontSize: '18px', color: '#999' }}>
                        Нет результатов тестирования
                    </p>
                </div>
            ) : (
                <div style={{ display: 'grid', gap: '15px' }}>
                    {results.map(result => (
                        <div key={result.id} className="card" style={{ padding: '25px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FiUser color="#4a90e2" size={18} />
                                            <strong style={{ fontSize: '16px' }}>
                                                {result.first_name} {result.last_name}
                                            </strong>
                                        </div>
                                        <span style={{
                                            padding: '4px 12px',
                                            background: result.passed ? '#f6ffed' : '#fff1f0',
                                            color: result.passed ? '#52c41a' : '#ff4d4f',
                                            borderRadius: '12px',
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px'
                                        }}>
                                            {result.passed ? <FiCheckCircle size={14} /> : <FiAlertCircle size={14} />}
                                            {result.passed ? 'Пройден' : 'Не пройден'}
                                        </span>
                                    </div>

                                    <div style={{ fontSize: '15px', color: '#666', marginBottom: '12px', marginLeft: '26px' }}>
                                        {result.username}
                                    </div>

                                    <div style={{ 
                                        padding: '12px 15px', 
                                        background: '#f9f9f9', 
                                        borderRadius: '8px',
                                        marginBottom: '12px'
                                    }}>
                                        <div style={{ fontWeight: '600', marginBottom: '5px', fontSize: '15px' }}>
                                            {result.test_title}
                                        </div>
                                        <div style={{ fontSize: '13px', color: '#999' }}>
                                            Проходной балл: {result.passing_score}%
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', gap: '25px', fontSize: '14px', color: '#666' }}>
                                        <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            <FiClock size={14} />
                                            {new Date(result.completed_at).toLocaleString('ru-RU')}
                                        </span>
                                        {result.time_spent && (
                                            <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                <FiClock size={14} />
                                                Время: {Math.floor(result.time_spent / 60)} мин
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div style={{ 
                                    display: 'flex', 
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: '10px',
                                    minWidth: '150px'
                                }}>
                                    <div style={{
                                        width: '100px',
                                        height: '100px',
                                        borderRadius: '50%',
                                        background: result.passed 
                                            ? 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)' 
                                            : 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '32px',
                                        fontWeight: 'bold',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                    }}>
                                        {Math.round(result.percentage)}%
                                    </div>
                                    <div style={{ textAlign: 'center', fontSize: '13px', color: '#666' }}>
                                        <div style={{ fontWeight: '600', color: '#333' }}>
                                            {result.score} / {result.max_score}
                                        </div>
                                        <div>баллов</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TestResultsPage;
